import actions from 'actions'

const defaultState = {
  email: null,
  formSubmitted: false,
}

export default function ticketingPage(state = defaultState, action) {
  switch (action.type) {
    case actions.SIGNUP_SUBMIT:
      return { email: action.data.email }
    case actions.SIGNUP_REQUEST.SUCCESS:
      return { formSubmitted: true }
    default:
      return state
  }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/pages/ticketing-page/ticketing-page.js
 **/